import DilemmaFormStepOne from "./dilemma-form-step-one";
import DilemmaFormStepTwo from "./dilemma-form-step-two";
import DilemmaFormStepThree from "./dilemma-form-step-three";
import DilemmaFormStepIndicator from "./dilemma-form-step-indicator";
import DilemmaFormStepSeparator from "./dilemma-form-step-separator";
import { useTranslation } from "react-i18next";
import { useDilemmasFormStore } from "../../stores/useDilemmaFormStore";
import DilemmaReviewComment from "./dilemma-review-comment";
import DilemmaChangesDialog from "./dilemma-changes-dialog";
import { DILEMMAS_STATUS } from "../../constants";

interface DilemmaFormProps {
  editMode?: boolean;
}

const DilemmaForm = ({ editMode }: DilemmaFormProps) => {
  const { t } = useTranslation();
  const currentStep = useDilemmasFormStore((s) => s.currentStep);
  const createdDilemma = useDilemmasFormStore((s) => s.createdDilemma);
  const isStep1Dirty = useDilemmasFormStore((s) => s.isStep1Dirty);
  const isStep2Dirty = useDilemmasFormStore((s) => s.isStep2Dirty);
  const isStep3Dirty = useDilemmasFormStore((s) => s.isStep3Dirty);

  return (
    <>
      <div className="lg:sticky lg:top-6 left-0 h-fit flex flex-col gap-4">
        <div className="bg-white p-4 py-6 rounded-md lg:border flex justify-center lg:flex-col gap-y-2">
          <DilemmaFormStepIndicator
            step={1}
            title={t("modules.dilemmas.form.steps.one.title")}
            isDirty={isStep1Dirty}
          />
          <DilemmaFormStepSeparator />
          <DilemmaFormStepIndicator
            step={2}
            title={t("modules.dilemmas.form.steps.two.title")}
            isDirty={isStep2Dirty}
          />
          <DilemmaFormStepSeparator />
          <DilemmaFormStepIndicator
            step={3}
            title={t("modules.dilemmas.form.steps.three.title")}
            isDirty={isStep3Dirty}
          />
        </div>
        {editMode &&
        createdDilemma?.source === "mobile" &&
        createdDilemma?.status === DILEMMAS_STATUS.SUBMITTED ? (
          <>
            <DilemmaReviewComment />
            <DilemmaChangesDialog />
          </>
        ) : null}
      </div>
      <div className="bg-white pt-4 lg:p-4 mb-28 rounded-md lg:border flex-1 h-fit">
        {currentStep === 1 && <DilemmaFormStepOne />}
        {currentStep === 2 && <DilemmaFormStepTwo />}
        {currentStep === 3 && <DilemmaFormStepThree />}
      </div>
    </>
  );
};

export default DilemmaForm;
